module.exports = __webpack_public_path__ + "img/34-Wrinkles.98c800c1.png";